module.exports = __webpack_public_path__ + "static/img/mix_cloud.e3cf6ae3.svg";